import React, { Component } from 'react';
import { matchRoutes } from 'react-router-config';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { getUserData } from '../../../store/selectors';
import isEmpty from 'lodash/isEmpty';
import { setUserData } from '../../../store/actions/userActions';
import Cookies from 'universal-cookie';
import EndpointsGetter from '../../../main/content/common/EndpointsGetter';
import axiosInstance from "../../../main/content/common/AxiosInstace";
import Config from "../../../config";
import NetworkDetection from "../../../hoc/NetworkDetection";

const cookies = new Cookies();
let redirect = false;

class FuseAuthorization extends Component {
    componentDidMount() {
        let accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            let user = localStorage.getItem('user');
            if (user) this.props.setUserData(JSON.parse(user));
            if (this.sessionCookiesExist()) {
                if (!this.matchingSessions(JSON.parse(user), cookies.get('user'))) this.refreshSession(window.location.href);
                else this.removeSessionCookies(window.location.href);
            }
        } else
            this.checkAuthentication();
    }

    componentDidUpdate(prevProps) {
        let accessToken = localStorage.getItem('access_token');
        if (isEmpty(prevProps.user) && !isEmpty(this.props.user)) {
            this.checkAuthorization();
        }

        if (accessToken && this.props.location.pathname === '/login') {
            this.props.history.push('/data-groups');
        }

        if (!isEqual(this.props.location.pathname, prevProps.location.pathname)) {
            this.checkAuthorization();
        }
    }

    checkAuthentication = () => {
        let url = window.location.href;
        if (this.sessionCookiesExist()) {
            if (cookies.get('user_accounts')) {
                this.props.history.push({
                    pathname: '/select-account',
                    state: {
                        userAccounts: cookies.get('user_accounts'),
                        accessToken: cookies.get('access_token')
                    }
                });
            } else {
                localStorage.setItem('access_token', cookies.get('access_token'));
                localStorage.setItem('refresh_token', cookies.get('refresh_token'));
                localStorage.setItem('expires_in', cookies.get('expires_in'));
                localStorage.setItem('set_in', new Date().getTime());
                this.getUserData();
                this.removeSessionCookies(url);
                this.props.history.push('/data-groups');
            }

        } else {
            if (!url.includes('localhost') && !url.includes('id') && !url.includes('verify-new-user-token')) {
                const loginDomain = url.includes('test') ? 'http://id.dev.test:3000' : Config.loginSubDomain;
                window.location.href = `${loginDomain}/login?continue=${encodeURIComponent(url)}`;
            }
        }
    }

    sessionCookiesExist = () => {
        return cookies.get('access_token') && cookies.get('refresh_token') && cookies.get('expires_in') && cookies.get('set_in');
    }

    getUserData = () => {
        axiosInstance.get(EndpointsGetter.getUserData(), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        })
            .then(response => {
                let user = response.data;
                this.props.setUserData(user);
                localStorage.setItem('user', JSON.stringify(user));
            })
            .catch(err => {
                console.log(err);
            })
    }

    removeSessionCookies = (url) => {
        const cookieDomain = url.includes('test') ? '.dev.test' : '.kanin.io';
        cookies.remove('access_token', { path: '/', domain: cookieDomain });
        cookies.remove('refresh_token', { path: '/', domain: cookieDomain });
        cookies.remove('expires_in', { path: '/', domain: cookieDomain });
        cookies.remove('set_in', { path: '/', domain: cookieDomain });
    }

    matchingSessions = (loggedUser, newUser) => {
        return loggedUser.id === newUser.id;
    }

    refreshSession = (url) => {
        localStorage.setItem('access_token', cookies.get('access_token'));
        localStorage.setItem('refresh_token', cookies.get('refresh_token'));
        localStorage.setItem('expires_in', cookies.get('expires_in'));
        localStorage.setItem('set_in', new Date().getTime());
        this.getUserData();
        this.removeSessionCookies(url);
    }

    checkAuthorization() {
        const matched = matchRoutes(this.props.routes, this.props.location.pathname)[0];
        if (matched && matched.route.auth && matched.route.auth.length > 0) {
            if (!matched.route.auth.includes(this.props.user.role)) {
                redirect = true;
                if (this.props.user.role === 'guest') {
                    this.props.history.push({
                        pathname: '/login',
                        state: { redirectUrl: this.props.location.pathname }
                    });
                }
                else {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        if (redirect) {
            redirect = false;
            return false;
        }
        else {
            return true;
        }
    }

    render() {
        const { children } = this.props;

        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    setUserData
};

const mapStateToProps = (state, ownProps) => {
    const userData = getUserData(state).user;
    return {
        user: userData
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NetworkDetection(FuseAuthorization)));



// WEBPACK FOOTER //
// ./src/@fuse/components/FuseAuthorization/FuseAuthorization.js